<template>
  <!-- 业务跟踪 -->
  <div>
    <div ref="searchBox">
      <div class="detailsTitle" style="justify-content: left; padding-top: 10px;margin-bottom: 0;">
        <div class="detailsTitle" style="margin-bottom: 0;">
          <h4>货物详情</h4>
        </div>
        <div style="margin-left: 10px;margin-top: 10px;">
          <el-button type="primary" size="mini" @click="fanhui">返 回</el-button>
        </div>
      </div>
      <div class=" formBox margbot">
      <el-form :inline="true" :model="searchFrom" ref="searchFrom" class="demo-form-inline" label-width="80px"
        size="mini">
        <div class="inpBox" style="padding-bottom: 5px;">
          <el-form-item label="捆包编号:">
            <el-input placeholder v-model="searchFrom.cargoBarcode"></el-input>
          </el-form-item>
          <el-form-item label="规格:">
            <el-input placeholder v-model="searchFrom.specification"></el-input>
          </el-form-item>

          <el-form-item label="材质:">
            <el-input placeholder v-model="searchFrom.model"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button btnCode="003P00RB001" type="primary" size="mini" @click="searchFn">查 询
            </el-button>
            <el-button btnCode="003P00RB002" type="primary" size="mini" @click="resetForm('searchFrom')">重置
            </el-button>
            <el-button btnCode="003P00RB002" type="primary" size="mini" @click="xiazai('searchFrom')">下载模板
            </el-button>
            <el-button btnCode="003P00RB002" type="primary" size="mini" @click="daoru('searchFrom')">导入
            </el-button>
          </el-form-item>
        </div>
      </el-form>
      </div>
    </div>
    <!--  表格 -->
    <div class="table" :style="{ height: h }">
      <el-table :data="tableList" ref="table" bordersize="mini" height="100%" style="width: 100%" center border>
        <el-table-column type="index" prop="date" width="55" label="序号"></el-table-column>
        <el-table-column property="orderNumber" width="100" label="订单编号"></el-table-column>
        <el-table-column property="demanderCustomer" width="180" label="需方客户"></el-table-column>
        <el-table-column property="productTypeName" width="100" label="货物名称"></el-table-column>
        <el-table-column property="cargoBarcode" width="180" label="钢卷号/捆包号"></el-table-column>
        <el-table-column property="model" width="120" label="材质"></el-table-column>
        <el-table-column property="specification" width="130" label="规格"></el-table-column>
        <el-table-column property="number" width="80" label="件数"></el-table-column>
        <el-table-column property="weight" width="100" label="重量（吨）"></el-table-column>
        <el-table-column property="placeLoad" width="180" label="装货地"></el-table-column>
        <el-table-column property="placeDischarge" width="180" label="卸货地"></el-table-column>
        <el-table-column property="consigneeContactInformation" width="150" label="收货人及联系方式"></el-table-column>
        <el-table-column property="shippingOutboundTime" width="180" label="发运出库时间"></el-table-column>
        <el-table-column property="carNumber" width="120" label="车号"></el-table-column>
        <el-table-column property="driverName" width="120" label="司机姓名"></el-table-column>
        <el-table-column property="telephone" width="120" label="联系电话"></el-table-column>
        <el-table-column property="deliveryReceiptTime" width="180" label="送达签收时间"></el-table-column>
        <el-table-column property="qualityObjections" width="180" label="质量异议"></el-table-column>
        <el-table-column property="remark" width="180" label="备注"></el-table-column>
      </el-table>
    </div>
    <!-- 分页 -->
    <div style="text-align: right;">
      <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
        :current-page="searchFrom.pageNo" :page-sizes="[25, 50, 100]" :page-size="searchFrom.pageSize"
        layout="total, sizes, prev, pager, next, jumper" :total="total"></el-pagination>
    </div>
      <!-- 导入 -->
      <daoru v-if="daoruMark" :daoruMark.sync="daoruMark" :markId="markId"></daoru>
  </div>
</template>

<script>
import { getBtn } from '@/utils/getButton'
import DonMessage from '@/utils/message'
import {
  getBusinessManagementGoodsList
} from '@/api/wms-stock'
import daoru from './daoruHW.vue'
export default {
  components: { daoru },
  data () {
    return {

      h: '500px',
      checkedGh: [],
      id: this.$route.query.id,
      addFrom: this.$route.query.addFrom,
      title: this.$route.query.title,
      total: 0,
      markId: '',
      daoruMark: false,
      searchFrom: {
        pageNo: 1,
        pageSize: 50
      },
      tableList: [],
      btnFlg: [],
      btnIdArr: ['003P00RB001', '003P00RB002']
    }
  },
  created () {
    this.btnFlg = getBtn(this.btnIdArr, '/tracking')

    this.getList()
  },
  mounted () {
    let h = this.$refs.searchBox.offsetHeight
    let pH = document.documentElement.clientHeight
    this.h = pH - h - 170 + 'px'
  },
  methods: {
    searchFn () {
      this.getList()
    },
    resetForm () {
      this.searchFrom = {
        pageNo: 1,
        pageSize: 50
      }
      this.getList()
    },
    xiazai () {
      window.open(
        'https://public-zw56.oss-cn-zhangjiakou.aliyuncs.com/template/wms/%E4%B8%9A%E5%8A%A1%E7%AE%A1%E7%90%86%E8%B4%A7%E7%89%A9%E6%98%8E%E7%BB%86%E5%AF%BC%E5%85%A5%E6%A8%A1%E7%89%88.xlsx'
      )
    },
    daoru () {
      this.daoruMark = true
      this.markId = this.id
      console.log(this.markId, 'markId')
    },
    fanhui () {
      this.$router.go(-1)// 返回上一层
    },

    // 获取列表
    getList () {
      const loading = this.$loading({
        lock: true,
        text: '正在处理...'
      })

      getBusinessManagementGoodsList({
        id: this.id,
        ...this.searchFrom
      }).then(res => {
        this.tableList = res.list
        this.total = res.total
        loading.close()
      }).catch((err) => {
        loading.close()
        DonMessage.error(err.message)
      })
    },

    // 每页条数
    handleSizeChange (val) {
      this.searchFrom.pageSize = val
      this.getList(this.searchFrom)
    },
    // 当前页
    handleCurrentChange (val) {
      this.searchFrom.pageNo = val
      this.getList(this.searchFrom)
    }

  }
}
</script>

<style scoped lang='less'>
.searchBtnBox {
  margin-left: 10px;
  margin-bottom: 10px;
}

.inpBox .el-date-editor {
  width: 350px !important;
}

.imgBox {
  display: flex;

  .item {
    display: flex;
    width: 50%;
    justify-content: space-around;
  }

  /deep/ .hide .el-upload--picture-card {
    display: none;
  }
}

.el-tag {
  margin: 0 4px !important;
}

.more_btn thead .el-table-column--selection .cell {
  display: none;
}

.liuxiang /deep/ .el-input__inner {
  width: 100%;
}

.liuxiang /deep/.el-select {
  width: 417px;
}
</style>
